<template>
  <button
    class="tooth-popup"
    type="button"
    v-bind:class="{ flip, selected }"
    v-on:click="toggle">
    <svg
      class="tooth-popup__parts"
      width="26"
      height="51"
      viewBox="0 0 26 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M6.63225 26.3866C6.36863 27.3399 5.82747 33.3464 5.58984 36.2305L20.4072 36.1268C19.9678 31.5848 18.9572 21.4025 18.43 17.009C17.7709 11.5171 14.1459 5.09267 12.564 3.27932C10.9822 1.46597 8.14814 1.25874 8.80723 4.78181C9.46632 8.30489 8.74132 15.6619 8.47769 17.5789C8.21405 19.4958 6.96178 25.1949 6.63225 26.3866Z" />
      <path d="M19.6822 46.6975C17.1513 48.7699 14.1458 49.3226 12.9595 49.3398C12.2479 49.1948 11.5629 48.9912 10.9104 48.7461C5.8532 46.847 2.73947 40.8208 5.58979 36.2319C5.88503 35.7566 6.2302 35.2877 6.6322 34.833C9.63765 31.4343 13.5966 31.8626 15.2004 32.5016C16.1451 32.9506 18.509 34.3046 20.4072 36.1283C22.3054 37.952 22.4724 40.7221 22.3186 41.8792C22.2527 42.6564 22.2131 44.6251 19.6822 46.6975Z" />
    </svg>
    <div class="tooth-popup__number">{{number}}</div>
  </button>
</template>

<script>
import popupTeethMixin from '@/mixins/popupTeethMixin';

export default {
  mixins: [popupTeethMixin],
  name: 'ToothUp5',
};
</script>

<style>
</style>
